/* ═══════════════════════════════════════════════════════
   Monmouth Cards — Collection Page JS
   assets/monmouth-collection.js
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* Real fix (pre-launch-remaining-fixes-prompt.md, Part 2) — confirmed
     live: this file is loaded twice on every real collection page, once
     sitewide via layout/theme.liquid and again unconditionally via
     sections/monmouth-collection-filters.liquid. With no guard, its full
     setup below (view toggle, sort select, every filter link, the AJAX
     bootstrap) ran twice for every real visitor — not an edge case like
     the admin-preview scenario the account-page bug lived in. Same
     pattern already proven in assets/monmouth-cart.js and
     assets/monmouth-mobile-fixes.js. */
  if (window.__mcCollectionInit) return;
  window.__mcCollectionInit = true;

  var SECTION_ID = 'monmouth-collection-filters';

  /* ══════════════════════════════════════════════════════
     GRID / LIST TOGGLE
  ══════════════════════════════════════════════════════ */
  function initViewToggle() {
    var toggleBtns = document.querySelectorAll('.mc-view-toggle__btn');
    if (!toggleBtns.length) return;

    var saved = localStorage.getItem('mc-view-mode');
    if (saved === 'list') setView('list');

    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var mode = btn.dataset.view;
        setView(mode);
        localStorage.setItem('mc-view-mode', mode);
      });
    });
  }

  function setView(mode) {
    var g = document.getElementById('mc-product-grid');
    if (!g) return;
    g.classList.toggle('mc-product-grid--list', mode === 'list');
    document.querySelectorAll('.mc-view-toggle__btn').forEach(function(b) {
      var active = b.dataset.view === mode;
      b.classList.toggle('mc-view-toggle__btn--active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ══════════════════════════════════════════════════════
     MOBILE FILTER SHEET
  ══════════════════════════════════════════════════════ */
  function initFilterSheet(keepOpen) {
    var sheet   = document.getElementById('mc-filter-sheet');
    var overlay = document.getElementById('mc-filter-sheet-overlay');
    var closeBtn = document.getElementById('mc-filter-sheet-close');
    /* New — header ✕ (filter-panel-redesign-prompt.md Part 2). Same
       closeSheet() the overlay/"Show X Results" already use; not a second
       close implementation. */
    var xBtn = document.getElementById('mc-filter-sheet-x');

    function openSheet() {
      if (!sheet) return;
      sheet.classList.add('mc-filter-sheet--active');
      if (overlay) overlay.classList.add('mc-filter-sheet-overlay--active');
      document.body.style.overflow = 'hidden';
    }
    function closeSheet() {
      if (!sheet) return;
      sheet.classList.remove('mc-filter-sheet--active');
      if (overlay) overlay.classList.remove('mc-filter-sheet-overlay--active');
      document.body.style.overflow = '';
    }

    var trig1 = document.getElementById('mc-filter-sheet-open');
    var trig2 = document.getElementById('mc-more-filters-trigger');
    if (trig1)    trig1.addEventListener('click', openSheet);
    if (trig2)    trig2.addEventListener('click', openSheet);
    if (overlay)  overlay.addEventListener('click', closeSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (xBtn)     xBtn.addEventListener('click', closeSheet);

    /* Real fix — re-apply the open state (classes + scroll lock) on the
       freshly-swapped-in sheet/overlay when it was open right before this
       swap, via the exact same openSheet() the trigger buttons use, so a
       filter tap from inside the sheet updates results live instead of
       closing it. See sheetWasActiveBeforeSwap above. */
    if (keepOpen) openSheet();
  }

  /* ══════════════════════════════════════════════════════
     SIDEBAR SCRIPTS
     Called after every section replace
  ══════════════════════════════════════════════════════ */
  function initSidebarScripts() {
    /* Collapsible groups */
    document.querySelectorAll('.mc-sidebar__group-toggle').forEach(function(btn) {
      var fresh = btn.cloneNode(true);
      btn.parentNode.replaceChild(fresh, btn);
      fresh.addEventListener('click', function() {
        var group  = this.closest('.mc-sidebar__group');
        var isOpen = group.classList.contains('mc-sidebar__group--open');
        group.classList.toggle('mc-sidebar__group--open', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    /* Show more / less */
    document.querySelectorAll('.mc-sidebar__more').forEach(function(btn) {
      var fresh = btn.cloneNode(true);
      btn.parentNode.replaceChild(fresh, btn);
      fresh.addEventListener('click', function() {
        var body       = this.closest('.mc-sidebar__group-body');
        var showCount  = parseInt(this.dataset.showCount, 10);
        var total      = parseInt(this.dataset.total, 10);
        var isExpanded = this.dataset.expanded === 'true';
        if (!isExpanded) {
          body.querySelectorAll('.mc-sidebar__option--hidden').forEach(function(el) {
            el.classList.remove('mc-sidebar__option--hidden');
          });
          this.textContent = '− Show less';
          this.dataset.expanded = 'true';
        } else {
          body.querySelectorAll('.mc-sidebar__option').forEach(function(el, i) {
            if (i >= showCount && !el.classList.contains('mc-sidebar__option--selected')) {
              el.classList.add('mc-sidebar__option--hidden');
            }
          });
          this.textContent = '+ ' + (total - showCount) + ' more';
          this.dataset.expanded = 'false';
        }
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     SORT SELECT
     2026-07-16: originally 4 of 5 options (Featured/Newest/Best Selling/
     Ending Soon) were tag filters wearing a sort dropdown's clothes —
     each shows ONLY products carrying that literal tag (sort-featured/
     sort-newest/sort-Bestseller/sort-endingSoon), not a reordering of
     the full set. Only "Price" was a genuine native sort, toggling
     ascending/descending on repeated selection rather than being two
     separate menu rows (data-current-sort-by on that <option>, set by
     Liquid, is how this reads "which direction am I on right now").
     2026-08-2X: Newest moved to the native-sort side too (team decision
     — real date sort across the whole catalog, see
     phase-4-newest-sort-and-per-page-prompt.md), modeled directly on the
     Price branch (data-native-sort-by on that <option>, set by Liquid,
     carries the exact collection.sort_by value to switch to — no
     ascending/descending toggle needed, unlike Price, since there's only
     one direction for "Newest"). Featured/Best Selling/Ending Soon are
     still routed through multiSelect.toggle() so they go through the
     exact same pipeline (URL building, AJAX fetch, pill rendering,
     composing with every other active filter) as every other
     single-toggle filter in this file — the 4-way exclusivity between
     them is handled by EXCLUSIVE_PAIRS above, not here.
  ══════════════════════════════════════════════════════ */
  function bindSortSelect() {
    document.querySelectorAll('.mc-filters-bar__sort-select').forEach(function(sel) {
      if (sel._mc_bound) return;
      sel._mc_bound = true;
      sel.addEventListener('change', function() {
        var opt = this.options[this.selectedIndex];
        var kind = opt.getAttribute('data-sort-kind');
        if (kind === 'price') {
          var currentSortBy = opt.getAttribute('data-current-sort-by') || '';
          var nextSortBy = currentSortBy === 'price-ascending' ? 'price-descending' : 'price-ascending';
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', nextSortBy);
          fetchAndReplace(url.toString());
        } else if (kind === 'native') {
          var nativeSortBy = opt.getAttribute('data-native-sort-by');
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', nativeSortBy);
          fetchAndReplace(url.toString());
        } else {
          multiSelect.toggle(this.value, null);
        }
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     AJAX — SHOPIFY SECTIONS RENDERING API
     Fetches /collections/X?filter=Y&sections=SECTION_ID
     Shopify returns JSON with perfectly rendered section HTML
     (correct filtered count, active filter states, updated grid)
  ══════════════════════════════════════════════════════ */
  var isLoading = false;
  /* Real fix — swapSectionHtml() below replaces .mc-collection-section's
     entire innerHTML with fresh server HTML, including #mc-filter-sheet/
     #mc-filter-sheet-overlay themselves, which always render in their
     default closed state. Without this, tapping a filter INSIDE the
     mobile sheet visually slams it shut on every tap, even though the
     tap correctly updates the results underneath. Captured right before
     each swap, consumed (and reset) by reinitAfterSwap() right after —
     see swapSectionHtml/initFilterSheet. */
  var sheetWasActiveBeforeSwap = false;

  function showLoading() {
    var section = document.querySelector('.mc-collection-section');
    if (section) {
      section.style.opacity = '0.45';
      section.style.pointerEvents = 'none';
      section.style.transition = 'opacity 0.15s';
    }
    /* Spinner */
    if (!document.getElementById('mc-ajax-spinner')) {
      var wrap = document.querySelector('.mc-collection-main') || document.querySelector('.mc-collection-section');
      if (wrap) {
        var sp = document.createElement('div');
        sp.id = 'mc-ajax-spinner';
        sp.innerHTML = '<div style="width:40px;height:40px;border:3px solid #e5e7eb;border-top-color:#0A1F44;border-radius:50%;animation:mc-spin .65s linear infinite;margin:auto;"></div>';
        sp.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:999;';
        if (!document.getElementById('mc-spin-kf')) {
          var s = document.createElement('style');
          s.id = 'mc-spin-kf';
          s.textContent = '@keyframes mc-spin{to{transform:rotate(360deg)}}';
          document.head.appendChild(s);
        }
        document.body.appendChild(sp);
      }
    }
  }

  function hideLoading() {
    var sp = document.getElementById('mc-ajax-spinner');
    if (sp) sp.remove();
    var section = document.querySelector('.mc-collection-section');
    if (section) {
      section.style.opacity = '';
      section.style.pointerEvents = '';
    }
  }

  /* Raw fetch of one collection URL's rendered section HTML — no swap,
     no history, no re-init. Building block for both the simple
     single-URL flow and the multi-select merge flow below. */
  function fetchSectionHtml(url) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var apiUrl = url + sep + 'sections=' + SECTION_ID;
    return fetch(apiUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var html = data[SECTION_ID];
        if (!html) throw new Error('Section not found in response');
        return html;
      });
  }

  function swapSectionHtml(html) {
    var section = document.querySelector('.mc-collection-section');
    /* Real fix — capture whether the mobile filter sheet was open BEFORE
       replacing it out from under itself; reinitAfterSwap() re-applies
       this on the new DOM right after. */
    var sheet = document.getElementById('mc-filter-sheet');
    sheetWasActiveBeforeSwap = !!(sheet && sheet.classList.contains('mc-filter-sheet--active'));
    if (section) section.innerHTML = html;
  }

  function reinitAfterSwap() {
    initSidebarScripts();
    bindAllFilterLinks();
    bindSortSelect();
    initFilterSheet(sheetWasActiveBeforeSwap);
    sheetWasActiveBeforeSwap = false;
    if (window.MC && typeof window.MC.initSinglesFilters === 'function') {
      window.MC.initSinglesFilters();
    }
    if (window.MC && typeof window.MC.initSealedFilters === 'function') {
      window.MC.initSealedFilters();
    }
    if (window.MC && typeof window.MC.initPokemonFilters === 'function') {
      window.MC.initPokemonFilters();
    }
    if (window.MC && typeof window.MC.initTcgSealedFilters === 'function') {
      window.MC.initTcgSealedFilters();
    }
    var viewPref = localStorage.getItem('mc-view-mode');
    if (viewPref === 'list') setView('list');
    var header = document.querySelector('.mc-collection-header');
    if (header) {
      setTimeout(function() {
        header.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }
  }

  function fetchAndReplace(url) {
    if (isLoading) return;
    isLoading = true;
    showLoading();

    fetchSectionHtml(url)
      .then(function(html) {
        swapSectionHtml(html);
        history.pushState({ mcUrl: url }, '', url);
        hideLoading();
        isLoading = false;
        reinitAfterSwap();
        multiSelect.bootstrapFromDom();
      })
      .catch(function(err) {
        console.warn('[MC] AJAX filter failed, falling back:', err);
        hideLoading();
        isLoading = false;
        window.location.href = url;
      });
  }

  /* ── Bind all filter + pagination links ── */
  function bindAllFilterLinks() {
    var selectors = [
      '.mc-sidebar__option',
      '.mc-filter-sheet__option',
      '.mc-sidebar__clear-all',
      '.mc-sidebar__pill',
      '.mc-pagination a'
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function(el) {
      /* Clone to remove any existing listeners */
      var fresh = el.cloneNode(true);
      el.parentNode.replaceChild(fresh, el);

      /* Sidebar/filter-sheet checkbox-style options route through the
         multi-select-aware engine (so they never silently drop an
         active OR-group); everything else (pagination, sort's own
         handler, clear-all) keeps the plain single-URL swap. */
      var isFilterOption = fresh.classList.contains('mc-sidebar__option') ||
                            fresh.classList.contains('mc-filter-sheet__option');

      if (isFilterOption && fresh.hasAttribute('data-tag')) {
        fresh.addEventListener('click', function(e) {
          e.preventDefault();
          multiSelect.toggle(this.getAttribute('data-tag'), this.getAttribute('data-category'));
        });
      } else if (fresh.classList.contains('mc-sidebar__clear-all')) {
        fresh.addEventListener('click', function(e) {
          e.preventDefault();
          multiSelect.clearAll();
        });
      } else {
        fresh.addEventListener('click', function(e) {
          var href = this.getAttribute('href');
          if (!href || href === '#') return;
          e.preventDefault();
          fetchAndReplace(href);
        });
      }
    });
  }

  /* ── Browser back / forward ──
     Re-derives multi-select state from the URL being navigated TO
     (not the stale DOM) and re-runs the same combo-fetch-and-merge
     pipeline as a click would, just without pushing a new history
     entry — the browser already has the right one. */
  window.addEventListener('popstate', function() {
    bootstrapFromLocation();
    var combos = computeCombos();
    renderCombos(combos, window.location.pathname + window.location.search, { pushState: false });
  });

  /* ══════════════════════════════════════════════════════
     MULTI-SELECT OR FILTER ENGINE
     Grading Company / Grade / Brand / Team can each have more than one
     value active at once ("PSA or SGC"). Shopify's own collection tag
     URLs only ever AND tags together (/handle/psa+sgc means "has both",
     not "has either" — no native OR without an app), so this fetches
     one Sections-API result PER selected value in an OR'd category,
     unions the returned products by dedupe, and stitches them into one
     grid. Categories with 0 or 1 value selected need no extra work and
     go through the plain single-fetch path.

     Known simplifications (documented, not silent):
     - Follows each combo's own pagination up to MAX_PAGES_PER_COMBO pages
       (not just page 1) so realistic category sizes come through close
       to complete, but a tag with more matches than that cap still won't
       show every one when OR'd with another. Also capped at MAX_COMBOS
       combos total, to avoid a request storm if several categories are
       multi-selected at once (worst case: MAX_COMBOS × MAX_PAGES_PER_COMBO
       requests).
     - Merged results aren't paginated (there's no single "page 2" across
       a union of several tags' own separate result sets) — pagination is
       hidden while a merge is active rather than shown broken.
     - Sort order is preserved *within* each combo's fetch but combos are
       simply concatenated after dedup, not globally re-sorted.

     The real Shopify URL (path-tag, AND-only) is used for every fetch.
     The *address bar* also carries a `mc_or` query param encoding which
     categories have 2+ values selected, purely so a page refresh or
     shared link restores the merge correctly instead of silently
     falling back to Shopify's own (wrong, AND-only) interpretation of
     that same path.
  ══════════════════════════════════════════════════════ */
  /* 'status' (TCG-Sealed's status- "Availability" checkbox) removed
     2026-07-16 — it duplicated the native Availability filter that
     already renders on every collection page, per user feedback.
     'rpgtype'/'players' added same day for RPG & Tabletop's Product Type
     /Player Count filters — 'brand'/'format' already existed and are
     reused as-is (RPG's Publisher/Format never coexist on a page with
     Sports/Wax's own Brand/Format). 'supply'/'fits'/'packsize' added
     same day for Supplies' Product/Fits Card Type/Pack Size — 'brand'
     reused again for Supplies' own Brand filter. 'mini'/'scale'/
     'ministate' added same day for Miniatures' Line/Scale/State —
     'brand' reused a fourth time for Miniatures' own Brand filter.
     'boardgame'/'age'/'playtime' added same day for Board Games' Type/
     Age Range/Play Time — 'brand' reused a fifth time and 'players' a
     second time (different real value sets than RPG's own Player Count,
     same safe-reuse reasoning). */
  var MULTI_CATEGORIES = ['grading-company', 'grade', 'brand', 'team', 'format', 'box-type', 'set', 'rarity', 'finish', 'lang', 'attr', 'character', 'sealedtype', 'year', 'game', 'rpgtype', 'edition', 'players', 'supply', 'fits', 'packsize', 'mini', 'scale', 'ministate', 'boardgame', 'age', 'playtime'];

  /* Pokemon Singles tags are namespaced (condition-Graded, gradingco-PSA,
     set-Prismatic Evolutions, ...) unlike Sports Singles' plain tags —
     stripped here purely for pill/chip display, same list the Liquid
     side strips in snippets/monmouth-filter-sidebar.liquid's pill loop.
     sealedtype-/year-/status- added for TCG & Pokemon Sealed collections
     (set-/lang- already covered above, reused from Wax/Pokemon). game-
     added for the combined tcg-pokemon page's Game filter. rpgtype-/
     edition-/players-/brand-/format- added for RPG & Tabletop — brand-/
     format- are new prefixed forms here even though the 'brand'/'format'
     categories already existed (Sports/Wax use those two unprefixed).
     supply-/fits-/packsize- added for Supplies. mini-/scale-/ministate-
     added for Miniatures. boardgame-/age-/playtime- added for Board
     Games. */
  var KNOWN_TAG_PREFIXES = ['condition-', 'gradingco-', 'grade-', 'set-', 'rarity-', 'finish-', 'lang-', 'player-', 'cardnum-', 'attr-', 'sealedtype-', 'year-', 'status-', 'game-', 'rpgtype-', 'edition-', 'players-', 'brand-', 'format-', 'supply-', 'fits-', 'packsize-', 'mini-', 'scale-', 'ministate-', 'boardgame-', 'age-', 'playtime-', 'sort-'];

  function stripKnownPrefix(tag) {
    for (var i = 0; i < KNOWN_TAG_PREFIXES.length; i++) {
      var p = KNOWN_TAG_PREFIXES[i];
      if (tag.slice(0, p.length) === p) return tag.slice(p.length);
    }
    return tag;
  }
  var MAX_COMBOS = 12;
  /* Condition: picking one drops the other. Two entries because Sports
     Singles writes the plain tag ('Graded'/'Ungraded' -> handleized
     'graded'/'ungraded') while Pokemon Singles writes the prefixed tag
     ('condition-Graded'/'condition-Ungraded' -> handleized 'condition-
     graded'/'condition-ungraded') — before this fix only the Sports pair
     matched, so on Pokemon pages picking Ungraded while Graded was active
     just AND'd both tags together (a card can never be both -> 0 results)
     instead of swapping. */
  /* Not just pairs despite the name — the toggle() logic below just needs
     "if the just-toggled tag's handle is in this group, drop every OTHER
     handle in the same group," which works for any group size. The Sort
     By dropdown's 4 tag options (2026-07-16) are mutually exclusive as a
     group of 4 for the same reason Condition's Graded/Ungraded are a
     group of 2 — picking one sort tag should replace whichever other
     sort tag was active, not AND together into a near-certain 0 results. */
  var EXCLUSIVE_PAIRS = [
    ['graded', 'ungraded'],
    ['condition-graded', 'condition-ungraded'],
    ['sort-featured', 'sort-newest', 'sort-bestseller', 'sort-endingsoon']
  ];

  function handleize(str) {
    // Preserve underscores (Shopify's own collection tag-URL routing does
    // not fold them into hyphens the way it does spaces/other punctuation
    // — e.g. tag "PRE_ORDER" must resolve to path segment "pre_order", not
    // "pre-order", or Shopify's server redirects instead of filtering).
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  var multiSelectState = { multi: {}, single: [] };
  MULTI_CATEGORIES.forEach(function(c) { multiSelectState.multi[c] = []; });

  function sidebarAttrs() {
    var aside = document.querySelector('.mc-sidebar');
    return {
      collectionUrl: (aside && aside.getAttribute('data-collection-url')) || '',
      requestSearch: (aside && aside.getAttribute('data-request-search')) || ''
    };
  }

  /* Buckets a flat tag list into { multi: {cat: [...]}, single: [...] }
     using the data-category map every [data-category] option in the
     currently-rendered sidebar carries. Shared by both bootstrap paths
     below — the only difference between them is WHERE the flat tag list
     comes from. */
  function categorizeTags(tags) {
    var catByHandle = {};
    document.querySelectorAll('.mc-sidebar__option[data-category]').forEach(function(el) {
      var t = el.getAttribute('data-tag');
      var c = el.getAttribute('data-category');
      if (t) catByHandle[handleize(t)] = c;
    });

    var next = { multi: {}, single: [] };
    MULTI_CATEGORIES.forEach(function(c) { next.multi[c] = []; });

    tags.forEach(function(t) {
      if (!t) return;
      var h = handleize(t);
      var cat = catByHandle[h];
      if (cat && next.multi[cat]) {
        if (next.multi[cat].indexOf(t) === -1) next.multi[cat].push(t);
      } else {
        next.single.push(t);
      }
    });
    return next;
  }

  function tagsFromPathname(pathname) {
    var attrs = sidebarAttrs();
    var rest = pathname;
    if (attrs.collectionUrl && rest.indexOf(attrs.collectionUrl) === 0) {
      rest = rest.slice(attrs.collectionUrl.length);
    }
    rest = rest.replace(/^\//, '');
    return rest ? rest.split('+') : [];
  }

  /* Source of truth after a normal AJAX section swap — data-current-tags
     on the freshly-swapped-in <aside> reflects exactly what the server
     just rendered for the primary combo. */
  function bootstrapFromDom() {
    var aside = document.querySelector('.mc-sidebar');
    var currentTagsRaw = (aside && aside.getAttribute('data-current-tags')) || '';
    var currentTags = currentTagsRaw ? currentTagsRaw.split('|') : [];
    multiSelectState = categorizeTags(currentTags);
    applyShareParamToState();
  }

  /* Source of truth for browser back/forward — data-current-tags is
     stale at that point (still describes the page *before* the nav), so
     this parses the tag list straight out of the new location instead. */
  function bootstrapFromLocation() {
    multiSelectState = categorizeTags(tagsFromPathname(window.location.pathname));
    applyShareParamToState();
  }

  function applyShareParamToState() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('mc_or');
    if (!raw) return;
    raw.split('|').forEach(function(part) {
      var sep = part.indexOf(':');
      if (sep === -1) return;
      var cat = part.slice(0, sep);
      var vals = part.slice(sep + 1).split(',');
      if (!multiSelectState.multi[cat]) return;
      vals.forEach(function(v) {
        var decoded = decodeURIComponent(v);
        if (decoded && multiSelectState.multi[cat].indexOf(decoded) === -1) {
          multiSelectState.multi[cat].push(decoded);
        }
      });
    });
  }

  function computeCombos() {
    var axes = [];
    var fixed = multiSelectState.single.slice();
    MULTI_CATEGORIES.forEach(function(cat) {
      var vals = multiSelectState.multi[cat];
      if (vals.length >= 2) {
        axes.push(vals.slice());
      } else if (vals.length === 1) {
        fixed.push(vals[0]);
      }
    });
    if (!axes.length) return [fixed];
    var combos = [fixed];
    axes.forEach(function(axisVals) {
      var next = [];
      combos.forEach(function(base) {
        axisVals.forEach(function(v) { next.push(base.concat([v])); });
      });
      combos = next;
    });
    return combos;
  }

  function buildComboUrl(comboTags) {
    var attrs = sidebarAttrs();
    var handles = comboTags.map(handleize).filter(Boolean);
    var path = handles.length ? '/' + handles.join('+') : '';
    return attrs.collectionUrl + path + attrs.requestSearch;
  }

  function buildShareableUrl(primaryComboUrl) {
    var url = new URL(primaryComboUrl, window.location.origin);
    var parts = [];
    MULTI_CATEGORIES.forEach(function(cat) {
      var vals = multiSelectState.multi[cat];
      if (vals.length >= 2) {
        parts.push(cat + ':' + vals.map(encodeURIComponent).join(','));
      }
    });
    if (parts.length) {
      url.searchParams.set('mc_or', parts.join('|'));
    } else {
      url.searchParams.delete('mc_or');
    }
    return url.pathname + url.search;
  }

  function cardKey(card) {
    var a = card.querySelector('a[href^="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  /* Merge mode hides pagination (there's no single "page 2" across a
     union of several tags' results), so a single page-1-only fetch per
     combo would badly under-represent any tag with more matches than one
     page holds — PSA alone runs well past 200 products on this catalog.
     These follow each combo's own "Next" link up to MAX_PAGES_PER_COMBO
     pages before giving up, so a merge is actually close to complete for
     realistic category sizes instead of just the first 24. */
  var MAX_PAGES_PER_COMBO = 8;

  function extractCards(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = doc.getElementById('mc-product-grid');
    return {
      cards: grid ? Array.from(grid.children) : [],
      hasNext: !!doc.querySelector('.mc-pagination__btn--next')
    };
  }

  function withPageParam(url, page) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('page', String(page));
    return u.pathname + u.search;
  }

  /* Fetches every page of one combo's results (page 1 included), up to
     the cap. Used for every combo except the primary one, which already
     has its page 1 in hand from the section swap. */
  function fetchAllComboCards(comboTags) {
    var url = buildComboUrl(comboTags);
    function loop(page, acc) {
      var pageUrl = page > 1 ? withPageParam(url, page) : url;
      return fetchSectionHtml(pageUrl).then(function(html) {
        var extracted = extractCards(html);
        var next = acc.concat(extracted.cards);
        if (extracted.hasNext && page < MAX_PAGES_PER_COMBO) {
          return loop(page + 1, next);
        }
        return next;
      }).catch(function() { return acc; });
    }
    return loop(1, []);
  }

  /* Fetches pages 2..N of one combo — for the primary combo, whose page 1
     is already live in the DOM (from the section swap or the initial
     page load), so it isn't re-fetched. */
  function fetchRemainingComboCards(comboTags, hasNext) {
    if (!hasNext) return Promise.resolve([]);
    var url = buildComboUrl(comboTags);
    function loop(page, acc) {
      return fetchSectionHtml(withPageParam(url, page)).then(function(html) {
        var extracted = extractCards(html);
        var next = acc.concat(extracted.cards);
        if (extracted.hasNext && page < MAX_PAGES_PER_COMBO) {
          return loop(page + 1, next);
        }
        return next;
      }).catch(function() { return acc; });
    }
    return loop(2, []);
  }

  /* Unions product cards from the currently-live grid (whatever combo[0]'s
     page 1 left in the DOM) plus a flat array of extra card elements
     already fetched for every other combo (and any extra pages of
     combo[0] itself, via fetchRemainingComboCards/fetchAllComboCards).
     Handles the case where combo[0] had zero matches — Shopify swaps in
     an ".mc-collection-empty" block instead of a grid for that, which
     would otherwise make the *whole* merge look empty even when another
     combo has real results — by creating a fresh grid element in its
     place. */
  function mergeGridFromCombos(extraCards) {
    var seen = {};
    var cards = [];
    var gridClassName = null;

    var liveGrid = document.getElementById('mc-product-grid');
    if (liveGrid) {
      gridClassName = liveGrid.className;
      Array.from(liveGrid.children).forEach(function(card) {
        var key = cardKey(card);
        if (key) { seen[key] = true; cards.push(card); }
      });
    }

    extraCards.forEach(function(card) {
      var key = cardKey(card);
      if (key && !seen[key]) { seen[key] = true; cards.push(card); }
    });

    if (!cards.length) return; /* nothing in any combo — leave the empty-state as-is */

    var main = document.querySelector('.mc-collection-main');
    if (!main) return;

    var grid = document.getElementById('mc-product-grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.id = 'mc-product-grid';
      grid.className = gridClassName || 'mc-product-grid';
      var empty = document.querySelector('.mc-collection-empty');
      if (empty) { empty.replaceWith(grid); } else { main.appendChild(grid); }
    }

    grid.innerHTML = '';
    cards.forEach(function(card) { grid.appendChild(card.cloneNode(true)); });

    /* No single "page 2" across a merged union — hide pagination rather
       than show a broken next-page link, and reflect the true (deduped)
       count instead of whatever page 1 alone reported. */
    var pagination = document.querySelector('.mc-pagination');
    if (pagination) pagination.remove();

    var countEl = document.querySelector('.mc-collection-header__count');
    if (countEl) {
      var n = cards.length;
      countEl.textContent = n + ' ' + (n === 1 ? 'product' : 'products');
    }
  }

  function syncCheckboxStates() {
    document.querySelectorAll('.mc-sidebar__option[data-category], .mc-filter-sheet__option[data-category]').forEach(function(el) {
      var cat = el.getAttribute('data-category');
      var tag = el.getAttribute('data-tag');
      if (!cat || !tag || !multiSelectState.multi[cat]) return;
      var active = multiSelectState.multi[cat].some(function(v) { return handleize(v) === handleize(tag); });
      el.classList.toggle('mc-sidebar__option--selected', active);
      el.setAttribute('aria-pressed', String(active));
    });
  }

  function rebuildPills() {
    var allSelectedTags = multiSelectState.single.slice();
    MULTI_CATEGORIES.forEach(function(cat) {
      allSelectedTags = allSelectedTags.concat(multiSelectState.multi[cat]);
    });

    /* "Clear all (N)" is server-rendered from the primary combo alone,
       which undercounts whenever an OR-group has 2+ values selected —
       fix it up here since we already have the true, full count. Any
       native (non-tag) filters like Price Range still add to N too, so
       add the difference rather than overwrite outright. */
    var clearAllLink = document.querySelector('.mc-sidebar__clear-all');
    if (clearAllLink) {
      var nativeMatch = clearAllLink.textContent.match(/\((\d+)\)/);
      var serverCount = nativeMatch ? parseInt(nativeMatch[1], 10) : 0;
      var serverTagCount = multiSelectState.single.length +
        MULTI_CATEGORIES.reduce(function(sum, cat) { return sum + (multiSelectState.multi[cat].length ? 1 : 0); }, 0);
      var nativeOnlyCount = Math.max(0, serverCount - serverTagCount);
      clearAllLink.textContent = 'Clear all (' + (nativeOnlyCount + allSelectedTags.length) + ')';
    }

    var container = document.querySelector('.mc-sidebar__active-pills');
    if (!container) return;

    /* Keep any non-tag pills already rendered server-side (Price Range) — only
       replace the tag pills, which is everything with a data-pill-tag marker. */
    container.querySelectorAll('[data-pill-tag]').forEach(function(el) { el.remove(); });

    /* Explicit label overrides for Sort By's 4 tag options — generic
       stripKnownPrefix() + first-letter-uppercase would leave
       "endingSoon" as "EndingSoon" with no space, same reasoning as the
       Liquid-side pill loop's override in monmouth-filter-sidebar.liquid. */
    var SORT_PILL_LABELS = {
      'sort-featured': 'Featured',
      'sort-newest': 'Newest',
      'sort-bestseller': 'Best Selling',
      'sort-endingsoon': 'Ending Soon'
    };

    allSelectedTags.forEach(function(tag) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'mc-sidebar__pill';
      pill.setAttribute('data-pill-tag', tag);
      var pillLabel = SORT_PILL_LABELS[handleize(tag)] || stripKnownPrefix(tag);
      var displayLabel = SORT_PILL_LABELS[handleize(tag)] ? pillLabel : (pillLabel.charAt(0).toUpperCase() + pillLabel.slice(1));
      pill.innerHTML = escapeHtml(displayLabel) +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" style="width:9px;height:9px;margin-left:4px;flex-shrink:0;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      pill.addEventListener('click', function() {
        var cat = findCategoryForTag(tag);
        multiSelect.toggle(tag, cat);
      });
      container.insertBefore(pill, container.firstChild);
    });
  }

  function findCategoryForTag(tag) {
    for (var i = 0; i < MULTI_CATEGORIES.length; i++) {
      var cat = MULTI_CATEGORIES[i];
      if (multiSelectState.multi[cat].some(function(v) { return v === tag; })) return cat;
    }
    return null;
  }

  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function finishApply() {
    hideLoading();
    isLoading = false;
    /* reinitAfterSwap() -> initSinglesFilters()/initSealedFilters() already
       renders Team/Set chips once for the fresh DOM; syncCheckboxStates/
       rebuildPills below don't change multiSelectState, just read it, so
       there's nothing left for a second chip-render to fix. */
    reinitAfterSwap();
    syncCheckboxStates();
    rebuildPills();
  }

  /* Fetches combos[0] as the primary full-section swap, then (if there's
     more than one combo) fetches the rest and merges their product cards
     in. Shared by user-driven filter clicks (pushState: true, default)
     and browser back/forward (pushState: false — the history entry for
     that URL already exists). */
  function renderCombos(combos, shareUrl, opts) {
    opts = opts || {};
    if (combos.length > MAX_COMBOS) {
      console.warn('[MC] ' + combos.length + ' filter combinations requested, capping at ' + MAX_COMBOS);
      combos = combos.slice(0, MAX_COMBOS);
    }

    var primaryUrl = buildComboUrl(combos[0]);

    if (isLoading) return;
    isLoading = true;
    showLoading();

    fetchSectionHtml(primaryUrl)
      .then(function(primaryHtml) {
        swapSectionHtml(primaryHtml);
        if (opts.pushState !== false) {
          history.pushState({ mcUrl: shareUrl }, '', shareUrl);
        }

        if (combos.length <= 1) {
          finishApply();
          return null;
        }

        var primaryHasNext = extractCards(primaryHtml).hasNext;
        var fetches = combos.map(function(comboTags, i) {
          return i === 0
            ? fetchRemainingComboCards(comboTags, primaryHasNext)
            : fetchAllComboCards(comboTags);
        });

        return Promise.all(fetches).then(function(cardArrays) {
          mergeGridFromCombos([].concat.apply([], cardArrays));
          finishApply();
        });
      })
      .catch(function(err) {
        console.warn('[MC] Multi-select filter failed, falling back to full navigation:', err);
        isLoading = false;
        hideLoading();
        window.location.href = shareUrl;
      });
  }

  function applyFilters() {
    var combos = computeCombos();
    var shareUrl = buildShareableUrl(buildComboUrl(combos[0]));
    renderCombos(combos, shareUrl);
  }

  /* Runs once on initial page load only: if the URL was opened directly
     (bookmark, shared link) with an `mc_or` param, the server already
     rendered combo[0]'s results (it has no idea what mc_or means) — this
     fetches and merges in the rest so the page matches what was shared,
     instead of silently showing just the first value. */
  function restoreShareUrlOnLoad() {
    if (!new URLSearchParams(window.location.search).get('mc_or')) return;
    var combos = computeCombos();
    if (combos.length <= 1) return;

    var primaryHasNext = !!document.querySelector('.mc-pagination__btn--next');
    var fetches = combos.map(function(comboTags, i) {
      return i === 0
        ? fetchRemainingComboCards(comboTags, primaryHasNext)
        : fetchAllComboCards(comboTags);
    });

    Promise.all(fetches).then(function(cardArrays) {
      mergeGridFromCombos([].concat.apply([], cardArrays));
      syncCheckboxStates();
      rebuildPills();
    });
  }

  var multiSelect = {
    bootstrapFromDom: bootstrapFromDom,
    getState: function() { return multiSelectState; },
    toggle: function(tag, category) {
      if (category && MULTI_CATEGORIES.indexOf(category) !== -1) {
        var list = multiSelectState.multi[category];
        var idx = list.findIndex(function(v) { return handleize(v) === handleize(tag); });
        if (idx !== -1) {
          list.splice(idx, 1);
        } else {
          list.push(tag);
        }
      } else {
        var single = multiSelectState.single;
        var sIdx = single.findIndex(function(v) { return handleize(v) === handleize(tag); });
        if (sIdx !== -1) {
          single.splice(sIdx, 1);
        } else {
          /* Condition (Graded/Ungraded) is mutually exclusive — picking
             one always drops the other rather than AND-ing to zero
             results, since a card can never be both. */
          var h = handleize(tag);
          EXCLUSIVE_PAIRS.forEach(function(pair) {
            if (pair.indexOf(h) !== -1) {
              pair.forEach(function(other) {
                if (other !== h) {
                  var oIdx = single.findIndex(function(v) { return handleize(v) === other; });
                  if (oIdx !== -1) single.splice(oIdx, 1);
                }
              });
            }
          });
          single.push(tag);
        }
      }
      applyFilters();
    },
    removeTag: function(tag) {
      this.toggle(tag, findCategoryForTag(tag));
    },
    clearAll: function() {
      MULTI_CATEGORIES.forEach(function(c) { multiSelectState.multi[c] = []; });
      multiSelectState.single = [];
      applyFilters();
    }
  };

  /* ══════════════════════════════════════════════════════
     PUBLIC HOOKS
     Lets other scripts (monmouth-singles-filters.js) trigger
     the same AJAX section-replace navigation and re-bind newly
     inserted filter links, instead of a hard page reload.
  ══════════════════════════════════════════════════════ */
  window.MC = window.MC || {};
  window.MC.fetchAndReplace = fetchAndReplace;
  window.MC.bindAllFilterLinks = bindAllFilterLinks;
  window.MC.handleize = handleize;
  window.MC.multiSelect = multiSelect;

  /* ══════════════════════════════════════════════════════
     INIT ON PAGE LOAD
  ══════════════════════════════════════════════════════ */
  initViewToggle();
  initFilterSheet();
  initSidebarScripts();
  bindAllFilterLinks();
  bindSortSelect();
  bootstrapFromDom();
  restoreShareUrlOnLoad();

})();
